<template>
	<div>
		<Modal :open-state="show" @close="() => show = false" id="modalSignIn" title="Авторизация">
			<div>
				<!-- <vue-recaptcha sitekey="6Ldj8XQfAAAAAAQPKOb-nR7eJ6y_smD4HwO8sNKW"> -->
				<button @click="$root.OAuth('vkontakte')" class="btn btn--lg btn--outline-vkontakte btn--block fields__item">
					<svg class="btn__icon" height="14" width="14"><use href="#svg-icon-vk"></use></svg>
					Войти через Вконтакте
				</button>
				<!-- </vue-recaptcha>
				<vue-recaptcha sitekey="6Ldj8XQfAAAAAAQPKOb-nR7eJ6y_smD4HwO8sNKW"> -->
				<button @click="$root.OAuth('telegram')" class="btn btn--lg btn--outline-telegram btn--block fields__item">
					<svg class="btn__icon" height="14" width="14"><use href="#svg-icon-tg"></use></svg>
					Войти через Телеграм
				</button>
				<button @click="$root.OAuth('google')" class="btn btn--lg btn--outline-google btn--block fields__item">
					<svg class="btn__icon" height="14" width="14"><use href="#svg-icon-google"></use></svg>
					Войти через Google
				</button>
				<button @click="$root.OAuth('mailru')" class="btn btn--lg btn--outline-mailru btn--block fields__item">
					<svg class="btn__icon" height="14" width="14"><use href="#svg-icon-mailru"></use></svg>
					Войти через mail.ru
				</button>
				<button @click="$root.OAuth('yandex')" class="btn btn--lg btn--outline-yandex btn--block fields__item">
					<svg class="btn__icon" height="14" width="14"><use href="#svg-icon-yandex"></use></svg>
					Войти через Yandex
				</button>
				<!-- </vue-recaptcha> -->
				<div class="fields__item">
					<label>Логин</label>
					<input v-model="username" class="text-field__input" placeholder="" @keyup.enter="login">
				</div>
				<div class="fields__item">
					<label>Пароль</label>
					<input v-model="password" type="password" class="text-field__input" placeholder="" @keyup.enter="login">
				</div>
				<div class="fields__item">
					<vue-recaptcha
						ref="recaptcha"
						cssClass="bonus-recaptcha"
						:sitekey="$root.$reCaptchaSiteKey"
						@verify="onCaptchaVerified"
						@expired="onCaptchaExpired">
					</vue-recaptcha>
				</div>

				<button v-if="!disableBtn" class="btn btn--lg btn--primary btn--block fields__item" @click="login" :disabled="disableBtn" @keyup.enter="login">
					Войти
				</button>
				<Loader class="fields__item" v-if="disableBtn" :loading="disableBtn" static/>

				<div class="text-center">Авторизуясь, вы соглашаетесь с<br class="hash-pc"> <a href="terms" target="_blanc">Правилами сайта</a></div>
			</div>
		</Modal>
	</div>
</template>

<script>
    import VueRecaptcha from './../../components/googlerecaptcha/GoogleReCaptcha.vue';
	import Modal from "../blocks/Modal.vue";
	import Loader from "../blocks/Loader.vue";

    export default {
        components: {
			Loader,
			Modal,
            VueRecaptcha
        },
        data() {
            return {
				show: false,
                username: '',
                password: '',
                errors: {
                    show: false,
                    message: ''
                },
                disableBtn: false,
                vktest: '',
                gRecaptchaResponse: null,
            }
        },

		mounted() {
			this.$root.emitter.on('showModalSignIn', () => this.show = true);
		},

		methods: {
            login() {
                if (!this.gRecaptchaResponse) {
                    return this.$toast.error('Необходимо пройти капчу');
                }

                if (!this.username) {
                    return this.$toast.error('Введите имя пользователя');
                }

                if (!this.password) {
                    return this.$toast.error('Введите пароль');
                }

                this.disableBtn = true;

                this.$root.graphql.getLoginUser({
                    username: this.username,
                    password: this.password,
                    recaptcha: this.gRecaptchaResponse
                }).then(res => {
                    const token = res.token;

                    if (token) {
                        this.$root.setAuthToken(token);                    
                        this.$root.getUser();
                        this.$root.recordUserData();
                    }
                    
                    this.disableBtn = false;
                    this.show = false
                }).catch(error => {
                    this.disableBtn = false;
                    this.$toast.error(this.$root.graphql.getError(error));
                    this.$cookie.delete('token');
                    this.onCaptchaExpired();
                });
            },
            onCaptchaVerified(response) {
                this.gRecaptchaResponse = response;
            },
            onCaptchaExpired() {
                this.$refs.recaptcha.reset()
            }
        }
    }
</script>